import { render, staticRenderFns } from "./getScreenOrientation.vue?vue&type=template&id=eafebf7e&scoped=true&"
import script from "./getScreenOrientation.vue?vue&type=script&lang=js&"
export * from "./getScreenOrientation.vue?vue&type=script&lang=js&"
import style0 from "./getScreenOrientation.vue?vue&type=style&index=0&id=eafebf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eafebf7e",
  null
  
)

export default component.exports